import React, { useEffect, useRef, useMemo } from 'react';

import CrossIcon from '../svg/cross';
import MinusIcon from "../svg/minus";


export default function DonationSlider({rangeValue, setRangeValue, STEP, rangeMax, setDonationChanged, children}) {
    const pathRef = useRef(null);
    const ballRef = useRef(null);
    const frameRef = useRef(null);
    const boundsRef = useRef(null);
    
    const sliderContainerRef = useRef(null);
    const dragStartRef = useRef({ x: 0, y: 0 });

    const rangeMin = 0;
    // const rangeMax = useMemo(() => {
    //     const max = (donationPrecentage * ticketsTotal) /100;
    //     return Math.ceil(max);
    // }, [ticketsTotal]);

    const handleSliderTouch = (e) => {
        if (!sliderContainerRef.current) return;

        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;
        dragStartRef.current = { x: clientX, y:  clientY};
        e.preventDefault();

        const rect = sliderContainerRef.current.getBoundingClientRect();
        // const x = clientX - rect.left;//
        const scrollAxisY = window.scrollY;
        const y = (clientY + scrollAxisY) - (rect.top + scrollAxisY);

        // const percentageX = getPercentage(x, rect.width);//
        const percentageY = 1 - getPercentage(y, rect.height);

        // const newValueX = rangeMin + (percentageX * (rangeMax - rangeMin));//
        const newValueY = rangeMin + (percentageY * (rangeMax - rangeMin));

        // const clampedX = snapToStep(newValueX, rangeMin, rangeMax, STEP);//
        const clampedY = snapToStep(newValueY, rangeMin, rangeMax, STEP);
        // setRangeValue(clampedX);//
        setRangeValue(clampedY);
        setDonationChanged(true);

        const handleDrag = (dragEvent) => {
            if (!sliderContainerRef.current) return;

            dragEvent.preventDefault();

            const dragRect = sliderContainerRef.current.getBoundingClientRect();
            // const dragClientX = dragEvent.touches ? dragEvent.touches[0].clientX : dragEvent.clientX;//
            const dragClientY = dragEvent.touches ? dragEvent.touches[0].clientY : dragEvent.clientY;

            // const dragX = dragClientX - dragRect.left;//
            const scrollAxisY = window.scrollY;
            const dragY = (dragClientY + scrollAxisY) - (dragRect.top + scrollAxisY);

            // const dragPercentageX = getPercentage(dragX, dragRect.width);//
            const dragPercentageY = 1 - getPercentage(dragY, dragRect.height);

            // const dragNewValueX = rangeMin + (dragPercentageX * (rangeMax - rangeMin));//
            const dragNewValueY = rangeMin + (dragPercentageY * (rangeMax - rangeMin));

            // let new_range_value = snapToStep(dragNewValueX, rangeMin, rangeMax, STEP);//
            let new_range_value = snapToStep(dragNewValueY, rangeMin, rangeMax, STEP);

            const threshold = 0.25;
            if (Math.abs(new_range_value - rangeMax) < threshold) {
                new_range_value = rangeMax;
            }

            setRangeValue(new_range_value);
            setDonationChanged(true);
        };

        const handleDragEnd = () => {
            document.removeEventListener('mousemove', handleDrag);
            document.removeEventListener('mouseup', handleDragEnd);
            document.removeEventListener('touchmove', handleDrag);
            document.removeEventListener('touchend', handleDragEnd);
        };

        document.addEventListener('mousemove', handleDrag);
        document.addEventListener('mouseup', handleDragEnd);
        document.addEventListener('touchmove', handleDrag, { passive: false });
        document.addEventListener('touchend', handleDragEnd);
    };

    const snapToStep = (value, min, max, step) => {
        const stepsFromMin = Math.round((value - min) / step);
        const snapped = min + stepsFromMin * step;

        return Math.min(Math.max(snapped, min), max);
    }

    // Utility to map axis coordinate position to slider percentage, reducing interactive area by 10%
    function getPercentage(axis, size) {
        const min = size * 0.10;
        const max = size * 0.90;
        const clamped = Math.max(min, Math.min(max, axis));

        return (clamped - min) / (max - min);
    }

    const DEBOUNCE_DELAY = 5; // to help with lag on Windows 10 Chrome
    const svgUpdateTimeout = useRef(null);

    useEffect(() => {
        if(rangeValue == null || !pathRef.current || !ballRef.current || !rangeMax) return;

        // Work out the numbers
        // let new_donation_amount = +(rangeValue - 30).toFixed(2);

        // setDonationAmount(new_donation_amount);

        // if (new_donation_amount == props.ticket.attribute_TicketDonation) {
        //     setDonationApplied(true);
        // } else {
        //     setDonationApplied(false);
        // }

        // Position the SVG
        if (svgUpdateTimeout.current) {
            clearTimeout(svgUpdateTimeout.current);
        }

        svgUpdateTimeout.current = setTimeout(() => {
            const ball = ballRef.current;

            const progress = Math.min(1, Math.max(0, (rangeValue - rangeMin) / (rangeMax - rangeMin)));

            // animation for ball
            const { top, bottom } = boundsRef.current.frame;
            const { centerOffset } = boundsRef.current.ball;

            const targetCenterY = bottom - progress * (bottom - top);
            const translateY = targetCenterY - centerOffset;
            
            ball.setAttribute(
                "transform",
                `translate(0 ${translateY})`
            );

            // animation for frame
            const { top: topFrame, bottom: bottomFrame } = boundsRef.current.frame;
            const heightFrame = bottomFrame - topFrame;

            const fillHeight = progress * heightFrame;
            const fillY = bottomFrame - fillHeight;

            frameRef.current.setAttribute('y', fillY);
            frameRef.current.setAttribute('height', fillHeight);
        }, DEBOUNCE_DELAY);

    }, [rangeValue, rangeMin, rangeMax]);


    useEffect(() => {
        if (!pathRef.current || !ballRef.current) return;

        // Path bounds
        const pathBBox = pathRef.current.getBBox();
        const ballBBox = ballRef.current.getBBox();

        boundsRef.current = { 
            ball: {
                centerOffset: ballBBox.y + ballBBox.height / 2
            },
            frame: {
                top: pathBBox.y,
                bottom: pathBBox.y + pathBBox.height
            }
        };

    }, []);

    return (
        <div className="donation-slider">
                    <div className='donation-slider__range'>
                        <div className='donation-slider__range-mask'
                            ref={sliderContainerRef}
                            onMouseDown={handleSliderTouch}
                            onTouchStart={handleSliderTouch}>
                        </div>
                        <input
                                type='range'
                                min='0'
                                step={STEP}
                                max={rangeMax}
                                value={rangeValue}
                                onChange={(e) => { if(e) setRangeValue(Number(e.target.value)) }}
                                style={{ pointerEvents: 'none' }}/>
                        

                        <svg aria-hidden="true" viewBox="0 0 174 326" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path ref={pathRef} d="M88.7412 81.9098H139.091V215.99H88.7412V81.9098ZM139.091 0V52.8003H88.7412V0H54V299.958H88.7412V245.057H139.091V300H174V0.042006L139.091 0Z" fill="#CDCDCD"/>

                            <g className='frame' clipPath="url(#fillClip)">
                                <path d="M88.7412 81.9098H139.091V215.99H88.7412V81.9098ZM139.091 0V52.8003H88.7412V0H54V299.958H88.7412V245.057H139.091V300H174V0.042006L139.091 0Z" fill="url(#paint0_linear_10601_5834)"/>
                            </g>


                            <g filter="url(#filter0_d_11912_6118)" ref={ballRef} className="ball"  transform-box="fill-box" transform-origin="center">
                                <rect x="10" y="286" width="28" height="28" rx="14" fill="#B80E80"/>
                                <rect x="10" y="286" width="28" height="28" rx="14" stroke="#B80E80" stroke-width="12"/>
                                <rect x="8.61534" y="284.308" width="31.3846" height="31.3846" rx="15.6923" fill="#F4F2F5"/>
                                <rect x="8.61534" y="284.308" width="31.3846" height="31.3846" rx="15.6923" fill='none' stroke="url(#paint0_linear_11912_6118)" stroke-width="1.84615"/>
                                <path d="M54 300L42 306.928L42 293.072L54 300Z" fill="#B80E80"/>
                            </g>

                            <defs>
                                <filter id="filter0_d_11912_6118" x="0" y="278" width="58" height="48" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                    <feOffset dy="2"/>
                                    <feGaussianBlur stdDeviation="2"/>
                                    <feComposite in2="hardAlpha" operator="out"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11912_6118"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11912_6118" result="shape"/>
                                </filter>
                                <linearGradient id="paint0_linear_11912_6118" x1="24.3077" y1="283.385" x2="24.3077" y2="316.615" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#F9FEFC"/>
                                    <stop offset="1" stopColor="#CDCDCD"/>
                                </linearGradient>

                                <clipPath id="fillClip" clipPathUnits="userSpaceOnUse">
                                    <rect
                                    ref={frameRef}
                                    x="0"
                                    y="306"
                                    width="174"
                                    height="0"
                                    />
                                </clipPath>

                                <linearGradient id="paint0_linear_10601_5834" x1="0" y1="-51.5252" x2="0" y2="282.364" gradientUnits="userSpaceOnUse">
                                    <stop offset="0.566554" stopColor="#B80E80"/>
                                    <stop offset="1" stopColor="#461D6C"/>
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <button 
                        type='button' 
                        className='btn'
                        onClick={()=> {
                                setRangeValue(rangeValue + STEP);
                                setDonationChanged(true);
                            }}>
                            <span class="sr-text">Increase donation</span>
                            <CrossIcon />
                    </button>
                    <button 
                        type='button' 
                        className='btn'
                        disabled = { rangeValue <= 0 }
                        onClick={()=> {
                                setRangeValue(rangeValue - STEP);
                                setDonationChanged(true);
                            }}>
                            <span class="sr-text">Reduce donation</span>
                            <MinusIcon />
                    </button>

                    {children}

        </div>
    )
}